import React from "react";
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.5 13a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zm0-.867A5.633 5.633 0 1 0 6.5.867a5.633 5.633 0 0 0 0 11.266zm-.3-3.132h.599c.11 0 .2.09.2.2V9.8a.2.2 0 0 1-.2.2H6.2a.2.2 0 0 1-.2-.2v-.599c0-.11.09-.2.2-.2zM6.2 3h.6c.11 0 .2.09.2.2v4.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2z"
  }
));
var ErrorIcon_default = ErrorIcon;
export {
  ErrorIcon_default as default
};
//# sourceMappingURL=ErrorIcon.js.map
